import { Box, Grid } from "@mui/material";
import { Field, useDmsForm } from "../../hooks/useDmsFrom";
import ControllerSelectInput from "../../common-ui/analytics/ControllerSelectInput";
import { DatePicker } from "../calender";

import { CountMetricsChart } from "./CountMetricsChart";

import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  startFetch,
  updateMaintenanceScheduleCountClassifier,
} from "../../store/reducers/analytics/maintenance-schedule.metrics";
import { MaintenanceCountQuery } from "../../services/analytics/maintenance";
import ControllerTextInput from "../../common-ui/analytics/ControllerTextInput";
import { DonorSelectInput } from "../../common-ui/select-input-models/DonorSelectInput";

const GroupByOptions = [
  {
    label: "Schedule status",
    value: "schedule_status",
  },
  {
    label: "service date",
    value: "service_date",
  },
  {
    label: "Ownership",
    value: "ownership",
  },
  {
    label: "Asset category",
    value: "asset_category",
  },
];

export const MaintenanceSchedulesMetricsController = () => {
  const defaultQuery = { group_by: "asset_category" };

  const { form, updateInputField, updateForm, getFormValues } =
    useDmsForm<MaintenanceCountQuery>({
      group_by: defaultQuery.group_by,
    });

  const handleDatePicker = (date: string) => {
    updateForm((p) => ({
      ...p,
      service_date: { value: date, isValid: true },
    }));
  };
  function handleDonorSelect(item: Field) {
    updateForm((p) => ({ ...p, donor_id: item }));
  }

  const { classifier } = useAppSelector((d) => d.maintenanceSchedulesMetrics);

  const dispatch = useAppDispatch();
  useEffect(() => {
    const query = getFormValues();
    dispatch(startFetch());
    dispatch(updateMaintenanceScheduleCountClassifier(query));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form.asset_id?.value,
    form.group_by?.value,
    form.schedule_status?.value,
    form.service_date?.value,
    form.donor_id?.value,
    form.serial_number,
    form.embossment_number,
  ]);

  const renderController = () => {
    return (
      <Box
        sx={(theme) => ({
          [theme.breakpoints.down("lg")]: {
            width: "100%",
          },
          [theme.breakpoints.up("lg")]: {
            maxWidth: 900,
          },
        })}
      >
        <Grid
          container
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12, lg: 12 }}
        >
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <Box width={180}>
              <DatePicker
                isBasic
                handleOnchange={handleDatePicker}
                label="Service Date"
              />
            </Box>
          </Grid>
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerSelectInput
              width={180}
              value={form.group_by?.value ?? undefined}
              placeholder="select classifier"
              items={GroupByOptions}
              handleChange={updateInputField("group_by")}
              label="Group By"
              loading={classifier?.loading ?? true}
            />
          </Grid>
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerTextInput
              width={180}
              value={form.serial_number?.value}
              placeholder="enter serial number"
              handleChange={updateInputField("serial_number")}
              label="Serial number"
            />
          </Grid>
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerTextInput
              width={180}
              value={form.embossment_number?.value}
              placeholder="enter embossment"
              handleChange={updateInputField("embossment_number")}
              label="Embossment number"
            />
          </Grid>
          <Grid item xs={2} sm={6} md={6} lg={3}>
            <ControllerTextInput
              width={180}
              value={form.asset_category?.value}
              placeholder="enter asset category name"
              handleChange={updateInputField("asset_category")}
              label="Asset Category"
            />
          </Grid>

          <Grid item xs={2} sm={6} md={3} lg={3}>
            <Box width={180}>
              <DonorSelectInput
                height="small"
                placeholder="Select Donor"
                label="Donor"
                handleChange={handleDonorSelect}
                value={form.donor_id?.value}
              />
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const refresh = () => {
    const query = getFormValues();
    dispatch(startFetch());
    dispatch(updateMaintenanceScheduleCountClassifier(query));
  };
  const reset = () => {
    dispatch(startFetch());
    updateForm({ group_by: { value: defaultQuery.group_by } });
    dispatch(updateMaintenanceScheduleCountClassifier(defaultQuery));
  };
  return (
    <CountMetricsChart
      title="Maintenance schedules Analytics"
      refresh={refresh}
      reset={reset}
      data={classifier?.data ?? {}}
      loading={classifier?.loading ?? true}
      controller={renderController()}
    />
  );
};
